// Data Store
export const GLOBAL_PREFERENCES = "GLOBAL_PREFERENCES";
export const SITE = "SITE";

// Tabs types
export const LOGS_TAB = "LOGS_TAB";
export const STATIC_TAB = "STATIC_TAB";
export const DYNAMIC_TAB = "DYNAMIC_TAB";
